import * as THREE from 'three';
import BaseMesh from '../BaseMesh.js';
import { MeshLine, MeshLineMaterial } from 'three.meshline';
const getThreeVertices = (points) => {
  const vertices = [];
  points.forEach(point => {
    vertices.push(new THREE.Vector3(point[0], point[1], point[2]));
  });
  return vertices;
};
const getSize = (points) => {
  let minX = Number.MAX_SAFE_INTEGER;
  let maxX = -Number.MAX_SAFE_INTEGER;
  let minY = Number.MAX_SAFE_INTEGER;
  let maxY = -Number.MAX_SAFE_INTEGER;
  points.forEach((point) => {
    minX = Math.min(minX, point[0]);
    maxX = Math.max(maxX, point[0]);
    minY = Math.min(minY, point[1]);
    maxY = Math.max(maxY, point[1]);
  });
  const width = maxX - minX;
  const height = maxY - minY;
  return { width, height };
};
class Index extends BaseMesh {
  constructor(data) {
    data.props['type'] = 'line';
    super(data);
    this.data = data;
    // 拆解数据
    const { points, zIndex } = data.props;
    console.log('line', data);
    const vertices = getThreeVertices(points);
    const { width, height } = getSize(points);
    const lineLength = Math.ceil(Math.sqrt(width ** 2 + height ** 2));
    const dashArray = 3 / lineLength;
    // 顶点的geometry（几何体）
    const geometry = new THREE.BufferGeometry().setFromPoints(vertices);
    const meshLine = new MeshLine();
    meshLine.setGeometry(geometry);
    meshLine.geometry.computeBoundingSphere();
    // meshLine.setPoints(vertices);
    const lineType = data.props?.lineType ?? 'basic';
    const transparent = data.props?.transparent ?? true;
    const color = data.props?.color ?? 'white';
    const lineWidth = data.props?.lineWidth ?? 3;
    const opacity = data.props?.opacity ?? 1;
    const dashedConfig = {};
    if (lineType === 'dashed') {
      dashedConfig['dashOffset'] = 1;
      dashedConfig['dashArray'] = dashArray; // 虚线占比，值越小虚线间隔越小
    }
    const material = new MeshLineMaterial({
      transparent: transparent,
      depthTest: false,
      // useMap: 0, // - 是否使用贴图 (0 - 不使用，用color中的颜色, 1 - 使用)
      lineWidth: lineWidth,
      color: color,
      opacity: opacity,
      // side: THREE.FrontSide,
      // sizeAttenuation: 1, //  线的大小是否会受相机影响。(0 - 不会, 1 - 会)
      ...dashedConfig,
    });
    const mesh = new THREE.Mesh(meshLine, material);
    mesh.renderOrder = zIndex;
    return mesh;
  }
}

export default Index;
